export default __webpack_public_path__ + "static/media/laban-400px.451f42a9.webp";